import { useCallback, useEffect, useState } from 'react';
import { rfqNotificationPrefsClient } from '../client/rfqNotificationPrefsClient';

/**
 * Whether Robbie may promise "I'll email you when they're done". The server
 * decides (`emailPromise`); the buyer can opt out for this RFQ.
 */
export const useResearchEmailPref = (rfqId: string | undefined, initialPromise: boolean | undefined) => {
  const [emailPromise, setEmailPromise] = useState(!!initialPromise);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => setEmailPromise(!!initialPromise), [initialPromise]);

  const optOut = useCallback(async () => {
    if (!rfqId) return;
    setSaving(true);
    setError(false);
    try {
      const prefs = await rfqNotificationPrefsClient.update(rfqId, { notifyOnResearchDone: false });
      setEmailPromise(!!prefs?.emailPromise);
    } catch {
      setError(true);
    } finally {
      setSaving(false);
    }
  }, [rfqId]);

  return { emailPromise, optOut, saving, error };
};

export default useResearchEmailPref;
